<template>
	<div>
		<!-- <clazy-load :src="`${key.url}.jpg`">
+			<img :src="`${key.url}.jpg`"  id="landscape" width="100%" class="img-hooper">
+			<div class="preloader text-center" slot="placeholder">
+				<img :src="`/images/home_slider/landscape/tp-10-descuento.jpg`"  id="landscape" width="100%" class="img-hooper">
+			</div>
		+		</clazy-load>-->
		<hooper
			class="landscape"
			:autoPlay="true"
			:playSpeed="4000"
			:infiniteScroll="true"
			:wheelControl="false"
		>
			<slide v-for="(key, index) of imagesland" :key="index">
				<a :href="key.link" target="_blank" v-if="key.link">
					<img
						:id="key.type"
						width="100%"
						class="img-hooper lazyload"
						:alt="key.title"
						:src="key.img_url"
					/>
				</a>
				<img v-else
					:id="key.type"
					width="100%"
					class="img-hooper lazyload"
					:alt="key.title"
					:src="key.img_url"
				/>
			</slide>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
			<hooper-navigation slot="hooper-addons"></hooper-navigation>
		</hooper>

		<hooper class="portrait" :autoPlay="true" :playSpeed="4000">
			<slide v-for="(key, index) of imagesport" :key="index">
				<a :href="key.link" target="_blank" v-if="key.link">
					<img
						:id="key.type"
						width="100%"
						class="img-hooper lazyload"
						:alt="key.title"
						:src="key.img_url"
					/>
				</a>
				<img v-else
					:id="key.type"
					width="100%"
					class="img-hooper lazyload"
					:alt="key.title"
					:src="key.img_url"
				/>
			</slide>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
			<hooper-navigation slot="hooper-addons"></hooper-navigation>
		</hooper>
	</div>
</template>
<script>
import {
	Hooper,
	Slide,
	Pagination as HooperPagination,
	Progress as HooperProgress,
	Navigation as HooperNavigation
} from 'hooper'
export default {
	props: {
		imagesland: Array,
		imagesport: Array,
		link: Boolean,
		device: String
	},
	components: {
		Hooper,
		Slide,
		HooperProgress,
		HooperNavigation,
		HooperPagination
	},
	data() {
		return {
		}
	},
}
</script>

<style lang="scss">
.slide-fade-enter-active {
	-webkit-animation: enter 0.5s; /* Safari 4.0 - 8.0 */
	// -webkit-animation-delay: 0.3s; /* Safari 4.0 - 8.0 */
	animation: enter 0.5s;
	// animation-delay: 0.3s;
	z-index: 100;
}
/* Safari 4.0 - 8.0 */
@-webkit-keyframes enter {
	from {
		-webkit-transform: translateX(100%);
		opacity: 0;
		visibility: hidden;
	}
	to {
		-webkit-transform: translateX(0px);
		opacity: 1;
		visibility: visible;
	}
}
@keyframes enter {
	from {
		transform: translateX(100%);
		opacity: 0;
	}
	to {
		transform: translateX(0px);
		opacity: 1;
	}
}
.slide-fade-leave-active {
	-webkit-animation: leave 0.5s; /* Safari 4.0 - 8.0 */
	-webkit-animation-delay: 0.1s;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 90;
}
/* Safari 4.0 - 8.0 */
@-webkit-keyframes leave {
	from {
		-webkit-transform: translateX(0);
		opacity: 1;
	}
	to {
		-webkit-transform: translateX(-100%);
		opacity: 0;
	}
}
@keyframes leave {
	from {
		transform: translateX(0);
		opacity: 1;
	}
	to {
		transform: translateX(-100%);
		opacity: 0;
	}
}
// (upright -> vetical)  (landscape -> horizontal)
@media only screen and (orientation: portrait) {
	.portrait {
		display: block;
		height: 100%;
		width: 100%;
	}
	.landscape {
		display: none;
	}
}
@media only screen and (orientation: landscape) {
	.portrait {
		display: none;
	}
	.landscape {
		display: block;
		height: 100%;
		width: 100%;
	}
}
.img-slider {
	width: 100%;
}
.hooper-prev {
	background-color: rgba(255, 250, 250, 0.4);
	padding: 8px;
	border-radius: 30px;
}
.hooper-next {
	background-color: rgba(255, 250, 250, 0.4);
	padding: 8px;
	border-radius: 30px;
}
</style>